import logo from '../images/ui/logo.png'
import expand from '../images/ui/expand.png'
import collapse from '../images/ui/collapse.png'

const uiImages = {
  logo: logo,
  expand: expand,
  collapse: collapse
}

export default uiImages

